import dateUtils from '../dateUtils/index.esm.js';
const daysInWeek = 7;
const defaultLocale = 'en-US';
const weekdayIndexes = {
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6
};
const capitalizeFirstLetter = ([firstChar, ...rest], locale) => {
  const capitalizedFirstLetter = firstChar.toLocaleUpperCase(locale);
  return [capitalizedFirstLetter, ...rest].join('');
};
const getIntDateTimeFormat = (locale, options) => {
  try {
    return new Intl.DateTimeFormat(locale, options);
  } catch (e) {
    return new Intl.DateTimeFormat(defaultLocale, options);
  }
};
const getWeekStartIndex = l10n => {
  const firstWeekdayCode = l10n.getWeekData().firstDay || 'sun';
  const firstWeekdayIndex = weekdayIndexes[firstWeekdayCode];
  return firstWeekdayIndex;
};
const getWeekdayNames = (l10n, locale = defaultLocale, weekday = 'long') => {
  const firstWeekdayIndex = getWeekStartIndex(l10n);
  const {
    format
  } = getIntDateTimeFormat(locale, {
    weekday
  });
  return Array.from(Array(daysInWeek).keys()).map(weekdayIndex => {
    // WeekIndex is zero based.
    const day = weekdayIndex + 1 + firstWeekdayIndex;
    // 2022-5-1 is a Sunday date.
    const weekDayName = format(new Date(2022, 4, day));
    // In some locales, days are capitalized shown as the first word in a phrase.
    return ['pt-BR', 'da-DK', 'nl-NL', 'nb-NO', 'no-NO', 'sv-SE'].includes(locale) ? capitalizeFirstLetter(weekDayName, locale) : weekDayName;
  });
};
const getMonthTitle = (year, month, locale = defaultLocale, monthLength = 'long') => {
  const {
    format
  } = getIntDateTimeFormat(locale, {
    year: 'numeric',
    month: monthLength
  });
  // MonthIndex is zero based.
  const monthLabel = format(new Date(year, month, 3));
  // In some locales, months are capitalized as the first word in a phrase.
  return ['da-DK'].includes(locale) ? capitalizeFirstLetter(monthLabel, locale) : monthLabel;
};
const getAriaLiveDate = (ISODateString, locale) => {
  if (!ISODateString) {
    return '';
  }
  const {
    format
  } = getIntDateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  });
  try {
    const date = dateUtils.getDateFromString(ISODateString);
    return format(date);
  } catch (e) {
    return '';
  }
};
export { daysInWeek, defaultLocale, getAriaLiveDate, getIntDateTimeFormat, getMonthTitle, getWeekStartIndex, getWeekdayNames };